module.exports = __webpack_public_path__ + "static/media/airbnb (1).9d2c0886.png";